export const score = (state) => {
  return Number(state.score);
};
